import Bus from './bus'
import { eventBus as FlatfinderBus } from '@kvass/flatfinder/src/Component.vue'

import { getCookie } from '@/utils'

function loadScript() {
  return new Promise((resolve, reject) => {
    var api = document.head.querySelector('[property="og:url"]')
    api = api ? api.getAttribute('content').split('/residential')[0] : ''
    var script = document.createElement('script')
    script.src = api + '/api/project/script.js?id=' + getCookie('kvass.project')
    script.type = 'text/javascript'

    script.addEventListener('load', () => {
      var isProxied = (function() {
        try {
          var ogUrlMeta = document.head.querySelector('[property="og:url"]')
          if (!ogUrlMeta) return false
          return new URL(ogUrlMeta.getAttribute('content')).host !== location.host
        } catch (e) {
          return false
        }
      })()

      if (isProxied) {
        var pmConsent = (function() {
          try {
            var raw = getCookie('CookieConsent')
            if (!raw) return null
            var obj = {}
            decodeURIComponent(raw).replace(/(\w+):(true|false|'[^']*'|\d+)/g, function(_, k, v) {
              obj[k] = v === 'true' ? true : v === 'false' ? false : v.replace(/^'|'$/g, '')
              return ''
            })
            return obj
          } catch (e) {
            return null
          }
        })()

        if (pmConsent && pmConsent.method === 'explicit') {
          var categories = ['required']
          if (pmConsent.preferences) categories.push('functional')
          if (pmConsent.statistics) categories.push('statistics')
          if (pmConsent.marketing) categories.push('marketing')

          if (window.Kvass) window.Kvass.emit('consent:change', categories)

          var pixel = new Image()
          pixel.src = api + '/api/legal/privacy/init?categories=' + encodeURIComponent(categories.join(','))
        }
        resolve()
        return
      }

      var privacy = document.createElement('script')
      privacy.src = api + '/api/legal/privacy/script.js'
      privacy.type = 'text/javascript'
      privacy.addEventListener('load', () => {
        if (document.readyState !== 'loading') {
          window.dispatchEvent(new Event('DOMContentLoaded'))
        }
      })
      document.head.appendChild(privacy)
      resolve()
    })

    document.head.appendChild(script)

    let scripts = [
      {
        defer: true,
        'data-domain': getCookie('kvass.project'),
        'data-api': api + '/api/insights/event',
        src: api + '/api/insights/script.js',
      },
    ]
      .map(entry => {
        const el = document.createElement('script')
        el.setAttribute('type', 'text/javascript')
        Object.entries(entry).forEach(([key, value]) => el.setAttribute(key, value))

        return el
      })
      .filter(Boolean)

    window.addEventListener('DOMContentLoaded', () =>
      scripts.forEach(el => {
        if (document.querySelector("script[src='" + el.getAttribute('src') + "']")) return
        document.body.appendChild(el)
      }),
    )
  })
}

FlatfinderBus.on('onChange', function() {
  Bus.emit('flatfinder:onChange', ...arguments)
})

export const scriptPromise = loadScript()

scriptPromise.then(() => window.Kvass.migrate(Bus))
export default Bus
